import { z } from 'zod'

export const manychatApiSchemas = {
  getPreviewState: {
    path: z.undefined(),
    query: z.object({
      share_hash: z.string(),
    }),
    response: z.object({
      channels: z.object({
        instagram: z
          .object({
            avatar_url: z.string().nullable(),
            business_id: z.number().nullable(),
            connected: z.boolean(),
            preview_keyword: z.string(),
            username: z.string().nullable(),
          })
          .optional(),
        tiktok: z
          .object({
            avatar_url: z.string().nullable(),
            connected: z.boolean(),
            preview_keyword: z.string(),
            username: z.string(),
          })
          .optional(),
      }),
    }),
  },
}
